//export const BASE_URL  = "https://kuryenew.herokuapp.com/api";

export const BASE_URL = "https://backend.istebikurye.com.tr/api"

//export const BASE_URL = "https://cc3b-160-120-170-183.ngrok-free.app/api"

export const UPLOAD_URL ="http://50.19.47.69:3000/api";